import Utils from '../components/Utils';

const HatUtils = {
    formatPercent: (value: number | undefined): string => {
        value = Math.abs(value || 0);
        value = value > 1 ? Utils.round(value, 0) : Utils.round(value, 2);

        return Utils.formatValue(Math.abs(value), 'percent') || '';
    },

    calculatePercent: (value: number, total: number): string => {
        const percent = (total > 0 ? value / total : 0) * 100;
        return HatUtils.formatPercent(percent);
    },
};

export default HatUtils;
